import { AbacoWebModule, RouterReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from './menu';
import FarmerRegistryModule, { MODULE_ID as FARM_MODULE_ID } from '@abaco/farm-registry/src/modules/farm-registry';
import GlobalStateModule, { MODULE_ID as GLOBAL_MODULE_ID } from '@abaco/portal-global-state/src/modules/global-state';
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module/index";
import { Farm } from '@abaco/farm-registry/src/modules/farm-registry/models/Farm';
import { Plot } from '@abaco/portal-global-state/src/modules/global-state/models/Plot';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import UrlApi from './api/UrlApi';

export const MODULE_ID = "base_embedded_sections_module";

export default class BaseEmbeddedSectionsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    private http!: HTTPClient;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly routes = myRoutes;
    menu: MenuItem[] = [];

    private apiCreated = false;
    private _urlApi!: UrlApi;

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;

        const UrlApi = (await import("./api/UrlApi")).default;
        this._urlApi = new UrlApi(http);
    }

    dependsOn = {
        [FARM_MODULE_ID]: () => new FarmerRegistryModule(),
        [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
    };

    onRouterReady(evt: RouterReadyEvent) {
        this.http = evt.http;
        this.menu = createMenu(evt.router);
    }

    public get urlApi(){
        return this._urlApi;
    }

    public async getFarm(subject_id: number): Promise<Farm>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/people_registry/subjects/${subject_id}`);
        return {
            cuaa: res.data.company_code,
            description: res.data.full_name,
            pk_cuaa: res.data.subject_id
        }
    }

    public async getPlot(plotId: number): Promise<Plot>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plotId}`);
        return res.data;
    }

}
